export default class StringSanitizer {
  public static getOnlyNumber(text: string) : string {
    if (!text) return text;
    const onlyNumbers = /[^0-9]/g;
    return text.replace(onlyNumbers, '');
  }
}
